import { create } from 'zustand';
import api from '@/lib/api';

/**
 * Feature-flags store (iter593).
 *
 * Centralises per-tenant feature toggles so any component can gate UI
 * behind a flag without re-fetching `/tenants/current` every render.
 *
 * Currently supports:
 *   - enable_partner_entries (default: false) — when ON, "Partner" rows
 *     appear in the Multi-Person Expense dialog, Banking Hub linker,
 *     Pass-Through Advances CTA, etc. Default OFF since most tenants
 *     never assign expenses to a partner.
 */
const DEFAULTS = {
  enable_partner_entries: false,
};

export const useFeatureFlagsStore = create((set) => ({
  flags: DEFAULTS,
  loaded: false,
  companyTz: undefined, // C3 — tenant.timezone, report date fallback

  loadFlags: async () => {
    try {
      const res = await api.get('/tenants/current');
      const raw = res.data?.tenant?.feature_flags || {};
      set({ flags: { ...DEFAULTS, ...raw }, loaded: true, companyTz: res.data?.tenant?.timezone || undefined });
    } catch {
      set({ flags: DEFAULTS, loaded: true });
    }
  },

  setFlag: async (key, value, extra = {}) => {
    // Optimistic — UI updates immediately; rollback on error.
    const prev = useFeatureFlagsStore.getState().flags;
    set({ flags: { ...prev, [key]: value } });
    try {
      const res = await api.put('/tenants/feature-flags', { key, value, ...extra });
      const merged = { ...DEFAULTS, ...(res.data?.feature_flags || {}) };
      set({ flags: merged });
      return merged;
    } catch (err) {
      set({ flags: prev });
      throw err;
    }
  },
}));
